import yup from 'validator';

const schema = yup.object().shape({
    regionName: yup.string().defined().required().label('Região'),
    state: yup.object().defined().required().label('Estado'),
    cities: yup.array().min(1).default([]).label('Cidades'),
});

export default schema;
